//react-components
import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

//Assets
import addUser from "../Assets/images/ic_add_user.svg";

//Styles
import "./UserList.scss";

//constants
import { DEFAULT_USER_SELECTION } from "./Constants";
import { DEFAULT_PAGINATION_ACTIVE_PAGE } from "../CustomUIComponents/Pagination/PaginationConstants";

//Custom UI Components
import SearchFilter from "../CustomUIComponents/SearchFilter/SearchFilter";
import Pagination from "../CustomUIComponents/Pagination/Pagination";

//Strings
import { Strings } from "../Translations/i18n";
import CustomModal from "../CustomUIComponents/CustomModal/CustomModal";
import ViewArchievedData from "../LoanApplicationList/ViewArchievedData";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchUsername: props.searchFilter.un,
      filterRole: props.searchFilter.uc,
      recordsPerPage: props.searchFilter.lmt,
      activePage: props.searchFilter.oft,
      isViewModal: false,
      isOpenArchievedButtonModal: false,
      auditScreen: "",
      auditType: "ADMIN_AUDIT",
    };
  }

  /**
   * This function will be called on change of user name in search
   */
  handleOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  /**
   * This function will be called on ckick of filter/search
   */
  handleOnClickSearchFilter = (isDefaultOffset) => {
    isDefaultOffset &&
      this.setState({
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      });

    this.props.handleOnClickSearchFilter({
      searchUsername: this.state.searchUsername
        ? this.state.searchUsername
        : "",
      filterRole:
        this.state.filterRole !== DEFAULT_USER_SELECTION
          ? this.state.filterRole
          : undefined,
      limit: this.state.recordsPerPage,
      offset: isDefaultOffset
        ? DEFAULT_PAGINATION_ACTIVE_PAGE
        : this.state.activePage,
    });
  };

  /**
   * This function will be called on reset button for search
   */
  handleOnClickResetSearch = () => {
    this.setState(
      {
        searchUsername: "",
        filterRole: "",
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      },
      () => {
        this.handleOnClickSearchFilter(false);
      }
    );
  };

  onPageChange = ({ page, pageLength }) => {
    this.setState(
      {
        activePage: page,
        recordsPerPage: pageLength,
      },
      () => {
        this.handleOnClickSearchFilter(false);
      }
    );
  };

  renderSearchFilter = () => {
    let filters = [
      {
        id: "firstName",
        type: "text",
        placeholder: "Usuario",
        name: "searchUsername",
        onChange: this.handleOnChange,
        value: this.state.searchUsername,
      },
      {
        id: "User",
        type: "select",
        placeholder: "Seleccionar usuario",
        name: "filterRole",
        onChange: this.handleOnChange,
        value: this.state.filterRole,
        dropdownList: this.props.userRoles,
      },
    ];
    return (
      <SearchFilter
        filters={filters}
        handleOnClickFilterSearch={this.handleOnClickSearchFilter}
        handleOnClickResetSearchValues={this.handleOnClickResetSearch}
        // handleRole={this.props.handleType}
      />
    );
  };

  toggleModal = (isViewModal = false) => {
    this.setState({
      isOpenArchievedButtonModal: !this.state.isOpenArchievedButtonModal,
      isViewModal,
    });
  };

  cancelClick = () => {
    this.setState({
      isOpenArchievedButtonModal: !this.state.isOpenArchievedButtonModal,
    });
  };

  onClickGenerateAudit = (id) => {
    this.props.generateAudit(id);
  };

  renderArchievedButtonModal = () => {
    return (
      <CustomModal
        open={this.state.isOpenArchievedButtonModal}
        closeModal={this.toggleModal}
        modalCloseOnEsc={false}
        modalCloseOnOverlayClick={false}
        modalShowCloseIcon={false}
        headerTextId={Strings("archievedData")}
      >
        <ViewArchievedData
          auditScreen={this.state.auditScreen}
          auditType={this.state.auditType}
          dropdownData={this.props.dropdownData}
          closeModal={this.toggleModal}
          isViewModal={this.state.isViewModal}
          cancelClick={this.cancelClick}
          onClickGenerateAudit={this.onClickGenerateAudit}
        />
      </CustomModal>
    );
  };

  render() {
    return (
      <div>
        {this.state.isOpenArchievedButtonModal &&
          this.renderArchievedButtonModal()}
        <div className="mainHeaderApplication d-flex justify-content-between">
          <div className="noPadding">{Strings("userManagement")}</div>
          <div className="userListFilterButtonPadding">
            <Button variant=""
              className="addOrUpdateUserTopButtons subHeaderApplication userListAddButtonChangeFont mx-1"
              onClick={this.props.handleAddUser}
            >
              <img src={addUser} alt="" />
              {Strings("addUser")}
            </Button>
            <Button variant=""
              className="addOrUpdateUserTopButtons mx-1"
              onClick={() => {
                this.toggleModal(false);
              }}
            >
              <i className="fa fa-archive addOrUpdateUserIcon" />
              {Strings("archievedData")}
            </Button>
          </div>
        </div>

        {/* Library component to display grid. */}
        <Col md={12}>{this.renderSearchFilter()}</Col>

        <Col md={12}>
          {this.props.rows.length !== 0 ? (
            <>
              <Row className={"amortizationHeader"}>
                {this.props.columns.map((column) => {
                  return (
                    <Col
                      md={
                        column.key === "firstName" || column.key === "role"
                          ? 3
                          : 2
                      }
                    >
                      {Strings(column.key)}
                    </Col>
                  );
                })}
              </Row>
              {this.props.rows.map((row) => {
                return (
                  <Row
                    className={"amortizationRows cursorPointer"}
                    onClick={() => this.props.onRowClick(row)}
                  >
                    {this.props.columns.map((column) => {
                      return (
                        <Col
                          md={
                            column.key === "firstName" || column.key === "role"
                              ? 3
                              : 2
                          }
                        >
                          {column.key === "image"
                            ? row[column.key]
                            : Strings(row[column.key])}
                        </Col>
                      );
                    })}
                  </Row>
                );
              })}
              <Pagination
                activePage={this.state.activePage}
                recordsPerPage={this.state.recordsPerPage}
                numberOfPages={this.props.numberOfPages}
                onPageChange={this.onPageChange}
                dropup={true}
              />
            </>
          ) : (
            <div className="noRecordsFound text-center">
              {Strings("noRecordsFound")}
            </div>
          )}
        </Col>
      </div>
    );
  }
}

export default UserList;
